<!--经销商资料(经销商)-->
<template>
  <div class="DealerProfile">
    <app-breadcrumb/>
    <div class="page-container account">
      <el-form :model="viewData" class="formData" label-position="right" label-width="40%">
        <div v-loading="loading" class="filter">
          <!--基本信息-->
          <p style="margin-top: 0;text-align: left;border-bottom: 1px dashed #616161;padding-bottom: 2px">
            {{ $t('Common.basicInfomation') }}</p>
          <!--代办处编号-->
          <el-form-item :label="$t('miAgent.agentNo')+':'">{{ viewData.agentNo }}</el-form-item>
          <!--经销商编号-->
          <el-form-item :label="$t('miMember.memberNo')+':'">{{ viewData.memberNo }}</el-form-item>
          <!--经销商姓名-->
          <el-form-item :label="$t('miMember.name')+':'">{{ viewData.name }}</el-form-item>
          <!--经销商级别-->
          <el-form-item :label="$t('miMember.cardType')+':'">
            {{ $lt(initDict.mimembercardtype, viewData.levelType) }}
          </el-form-item>
          <!--荣衔-->
          <el-form-item :label="$t('mi.honourLevel')+':'">
            {{ $lt(initDict.mimemberhonourLevel, viewData.cardType) }}
          </el-form-item>
          <!--状态-->
          <el-form-item :label="$t('pmProductList.status')+':'">
            {{ $lt(initDict.mimemberstatus, viewData.status) }}
          </el-form-item>
          <!--证件类型-->
          <el-form-item :label="$t('miAgent.paperType')+':'">
            {{ $lt(initDict.miagentpapertype, viewData.paperType) }}
          </el-form-item>
          <!--证件号-->
          <el-form-item :label="$t('miAgent.paperNo')+':'">{{ viewData.paperNo }}</el-form-item>
          <!--PAN Information Modification-->
          <el-form-item v-show="!isShow&&companyCode==='IN'" :label="$t('PAN Information Modification')+':'">
            <el-switch
                v-model="Switch"
                active-color="#13ce66"
                inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
          <!--PAN编号-->
          <el-form-item v-show="companyCode==='IN'" :label="$t('in.pan.no')+':'">
            <span v-show="!Switch">{{ viewData.panNo }}</span>
            <el-input v-show="Switch" v-model.trim="editData.panNo" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--正面照片-->
          <el-form-item v-show="!Switch&&companyCode==='IN'" :label="$t('in.front.photo')+':'">
            <img
                v-if="viewData.panFile"
                :alt="$lt('in.front.photo ', viewData.panFile)"
                :src="require('@/assets/images/grade/mem_grade_'+ viewData.panFile +'.gif')"
                :title="$lt('in.front.photo', viewData.panFile)"
            />
          </el-form-item>
          <!--正面照片 图片上传-->
          <el-form-item v-show="Switch&&companyCode==='IN'" :label="$t('Please upload the correct scan copy')+':'">
            <el-upload
                :before-remove="beforeRemove"
                :file-list="fileList"
                :limit="3"
                :on-exceed="handleExceed"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                action="https://jsonplaceholder.typicode.com/posts/"
                class="upload-demo"
                multiple>
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">{{ $t('jpg.png.files.less.than.500kb') }}</div>
            </el-upload>
          </el-form-item>
          <!--Verification Status-->
          <el-form-item v-show="companyCode==='IN'" :label="$t('Verification Status')+':'">
            {{ $lt(initDict.yesno, viewData.panstatus) }}
          </el-form-item>
          <!--GST编号-->
          <el-form-item v-show="companyCode==='IN'" :label="$t('in.gst.no')+':'">
            <span v-show="isShow">{{ viewData.gstNo }}</span>
            <el-input v-show="!isShow" v-model.trim="editData.gstNo" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--奖金发放方式-->
          <el-form-item :label="$t('bd.bonusSendType')+':'">
            <span v-show="isShow">{{ $lt(initDict.mimemberbonusSsendType, viewData.bonusSendType) }}</span>
            <el-select v-show="!isShow" v-model="editData.bonusSendType">
              <el-option v-for="i in mimemberbonusSsendType" :key="i.code" :label="$t(i.title)" :value="i.code"/>
            </el-select>
          </el-form-item>
          <!-- companyCode===ID          -->
          <el-form-item v-if="this.companyCode === 'ID' " v-show="companyCode==='IN'"
                        :label=" 'Minggu Aktif Tersisa' +':'">
            {{ $lt(initDict.yesno, viewData.onvnum) }}
          </el-form-item>
          <el-form-item v-if="this.companyCode === 'ID' " v-show="companyCode==='IN'"
                        :label="'Tanggal hari terakhir untuk Bonus Elite' + ':'">
            {{ $lt(initDict.yesno, viewData.timeend) }}
          </el-form-item>
          <!--收货地址-->
          <p style="margin-top: 0;text-align: left;border-bottom: 1px dashed #616161;padding-bottom: 2px">
            {{ $t('register.us.legend.shipping') }}</p>
          <!--所在地区-->
          <el-form-item v-show="!isShow" :label="$t('miAgent.regionCode')">
            <el-col :span="6">
              <el-select
                  v-model="countrymodel"
                  :placeholder="$t('please.select.country.or.region')"
                  clearable
                  size="mini"
                  value-key="regionId"
                  @change="countrychange"
              >
                <el-option
                    v-for="item in addchoicecountry"
                    :key="item.regionId"
                    :label="item.regionName"
                    :value="item"
                />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select
                  v-model="provincemodel"
                  :placeholder="$t('please.select.province')"
                  clearable
                  size="mini"
                  value-key="regionId"
                  @change="provincechange"
              >
                <el-option
                    v-for="item in addchoiceprovince"
                    :key="item.regionId"
                    :label="item.regionName"
                    :value="item"
                />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select
                  v-model="citymodel"
                  :placeholder="$t('please.select.city')"
                  clearable
                  size="mini"
                  value-key="regionId"
                  @change="citychange"
              >
                <el-option
                    v-for="item in addchoicecity"
                    :key="item.regionId"
                    :label="item.regionName"
                    :value="item"
                />
              </el-select>
            </el-col>
          </el-form-item>
          <!--详细地址-->
          <el-form-item :label="$t('miAgent.storeAddr')+':'">
            <span v-show="isShow">{{ viewData.storeAddr }}</span>
            <el-input v-show="!isShow" v-model.trim="editData.storeAddr" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--邮政编码-->
          <el-form-item :label="$t('miAgent.storePost')+':'">
            <span v-show="isShow">{{ viewData.storePost }}</span>
            <el-input v-show="!isShow" v-model.trim="editData.storePost" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--传真-->
          <el-form-item :label="$t('miAgent.fax')+':'">
            <span v-show="isShow">{{ viewData.fax }}</span>
            <el-input v-show="!isShow" v-model.trim="editData.fax" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--移动电话-->
          <el-form-item :label="$t('miAgent.mobile')+':'">
            <span v-show="isShow">{{ viewData.mobile }}</span>
            <el-input v-show="!isShow" v-model.trim="editData.mobile" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--银行账户信息-->
          <p style="margin-top: 0;text-align: left;border-bottom: 1px dashed #616161;padding-bottom: 2px">
            {{ $t('miAgent.title.accountInfo') }}</p>
          <!--Bank Account Information Modification?-->
          <el-form-item v-show="!isShow&&companyCode==='IN'" :label="$t('Bank Account Information Modification?')">
            <el-switch
                v-model="Switch2"
                active-color="#13ce66"
                inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
          <!--开户银行-->
          <el-form-item :label="$t('miAgent.accountBank')+':'">
            <span v-show="!Switch2">{{ viewData.accountBank }}</span>
            <el-select v-show="Switch2" v-model="editData.accountBank">
              <el-option v-for="i in $ll('mm.bank.list')" :key="i.code" :label="$t(i.title)" :value="i.code"/>
            </el-select>
          </el-form-item>
          <!--户名-->
          <el-form-item :label="$t('miAgent.accountName')+':'">{{ viewData.accountName }}</el-form-item>
          <!--帐号-->
          <el-form-item :label="$t('miAgent.accountCode')+':'">
            <span v-show="!Switch2">{{ viewData.accountCode }}</span>
            <el-input v-show="Switch2" v-model.trim="editData.accountCode" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--IFSC编号-->
          <el-form-item v-show="companyCode==='IN'" :label="$t('in.ifsc.code')+':'">
            <span v-show="!Switch2">{{ viewData.ifscCode }}</span>
            <el-input v-show="Switch2" v-model.trim="editData.ifscCode" size="mini" style="width: 170px"/>
          </el-form-item>
          <!--Photo Copy-->
          <el-form-item v-show="companyCode==='IN'" :label="$t('Photo Copy')+':'">
            <img
                v-if="viewData.chequeCopy"
                :alt="$lt('Photo Copy', viewData.chequeCopy)"
                :src="require('@/assets/images/grade/mem_grade_'+ viewData.chequeCopy +'.gif')"
                :title="$lt('Photo Copy', viewData.chequeCopy)"
            />
          </el-form-item>
          <!--图片上传-->
          <el-form-item v-show="Switch2&&companyCode==='IN'" :label="$t('Please upload the correct scan copy')+':'">
            <el-upload
                :before-remove="beforeRemove"
                :file-list="fileList"
                :limit="3"
                :on-exceed="handleExceed"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                action="https://jsonplaceholder.typicode.com/posts/"
                class="upload-demo"
                multiple>
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">{{ $t('jpg.png.files.less.than.500kb') }}</div>
            </el-upload>
          </el-form-item>
          <!--Verification Status-->
          <el-form-item v-show="companyCode==='IN'" :label="$t('Verification Status')+':'">
            {{ $lt(initDict.yesno, viewData.bankstatus) }}
          </el-form-item>
          <el-form-item>
            <!--编辑-->
            <el-button v-show="isShow" type="primary" @click="editEditData">{{ $t('button.edit') }}</el-button>
            <!--保存-->
            <el-button v-show="!isShow" type="success" @click="upEditDate">{{ $t('button.save') }}</el-button>
            <!--取消-->
            <el-button v-show="!isShow" type="danger" @click="cancelEditData">{{
                $t('operation.button.cancel')
              }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>

import {memberInfoEdit} from "@/api/ay-personal-center/personalcenter";
import {getAlRegionsByCode, getLevel1AlRegions, miMemberInfo} from '@/api/member'
import {mapGetters} from 'vuex'

export default {
  name: 'DealerProfile',
  directives: {},
  components: {},
  props: [],
  data() {
    return {
      isShow: true,
      Switch: false,
      Switch2: false,
      loading: false,
      bonusSendType: [],
      editData: {},
      viewData: {},
      languages: [
        {code: 'zh_CN', name: 'Chinese 中文'},
        {code: 'de_DE', name: 'Deutsch 德语'},
        {code: 'en_GB', name: 'English 英语'},
        {code: 'fr_FR', name: 'Français 法语'},
        {code: 'in_ID', name: 'Indonesia 印尼语'},
        {code: 'lt_LT', name: 'Lietuvių 立陶宛语'},
        {code: 'pl_PL', name: 'Polski 波兰语'},
        {code: 'tr_TR', name: 'Türkiye 土耳其语'},
        {code: 'cs_CZ', name: 'Čeština 捷克语'},
        {code: 'mn_MN', name: 'Монгол 蒙古语'},
        {code: 'ru_RU', name: 'Русский 俄语'},
        {code: 'th_TH', name: 'ภาษาไทย 泰语'}
      ],
      initDict: {
        mimembercardtype: 'cn.member.level',  //经销商级别
        mimemberhonourLevel: 'cn.mimember.cardtype',    //荣衔
        miagentpapertype: 'miagent.papertype', //证件类型
        mimemberstatus: 'mimember.status',  //状态
        mimemberbonusSsendType: 'bd.bonus_send_type',  //奖金发放方式
        yesno: 'yesno',
      },
      fileList: [],
      countrymodel: '', // 新增选择地区model
      provincemodel: '', // 新增选择省存储model
      citymodel: '', // 新增选择市存储model
      areamodel: '', // 新增选择县存储model
      addchoicecountry: [], // 新增选择国家存储
      addchoiceprovince: [], // 新增选择省存储
      addchoicecity: [], // 新增选择市存储
      addchoicearea: [], // 新增选择县存储
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
    ]),
    yesno() {
      return this.$ll(this.initDict.yesno)
    },
    mimembercardtype() {
      return this.$ll(this.initDict.mimembercardtype)
    },
    mimemberhonourLevel() {
      return this.$ll(this.initDict.mimemberhonourLevel)
    },
    miagentpapertype() {
      return this.$ll(this.initDict.miagentpapertype)
    },
    mimemberstatus() {
      return this.$ll(this.initDict.mimemberstatus)
    },
    mimemberbonusSsendType() {
      return this.$ll(this.initDict.mimemberbonusSsendType)
    }

  },
  watch: {},
  created() {
    // this.bonusSendType = this.$ll('bd.bonus_send_type')
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      miMemberInfo({'memberNo': this.userCode}).then(res => {
        this.viewData = res.data
        this.viewData.langName = res.data.langCodeList.langName
        this.loading = false
        this.isShow = true
        this.Switch = false
        this.Switch2 = false
      }).catch(err => {
        console.warn(err)
        this.loading = false
        this.isShow = true
        this.Switch = false
        this.Switch2 = false
      })
    },
    editEditData() {
      this.isShow = false
      this.Switch = true
      this.Switch2 = false
      this.editData = JSON.parse(JSON.stringify(this.viewData))
      getLevel1AlRegions({'regionId': 0}).then(res => {
        this.addchoicecountry = res.data
      })
    },
    cancelEditData() {
      this.getData()
      this.isShow = true
      this.Switch = false
      this.Switch2 = false
    },
    upEditDate() {
      this.loading = true
      memberInfoEdit({...this.editData}).then(res => {
        if (res.success) {
          this.getData()
          this.isShow = true
          this.loading = false
          this.$notify({
            title: '',
            message: this.$t('miMember.updated'),
            type: 'success'
          })
        }
      }).catch(err => {
        console.warn(err)
        this.loading = false
      })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 新增按钮 - 国家change事件
    countrychange(val) {
      this.provincemodel = null
      this.citymodel = null
      this.areamodel = null
      this.countrymodel = val.regionName
      this.editData.country = val.regionId
      getAlRegionsByCode({'regionCode': val.regionCode}).then(res => {
        this.addchoiceprovince = res.data
      }).catch(() => {
      })
    },
    // 新增按钮 - 省change事件
    provincechange(val) {
      this.citymodel = null
      this.areamodel = null
      this.provincemodel = val.regionName
      this.editData.province = val.regionId
      getAlRegionsByCode({'regionCode': val.regionCode}).then(res => {
        this.addchoicecity = res.data
      }).catch(() => {
      })
    },
    // 新增按钮 - 市change事件
    citychange(val) {
      this.areamodel = null
      this.citymodel = val.regionName
      this.editData.city = val.regionId
      getAlRegionsByCode({'regionCode': val.regionCode}).then(res => {
        this.addchoicearea = res.data
      }).catch(() => {
      })
    },
  }
}
</script>
<style lang="scss" scoped>

.formData ::v-deep .el-form-item {
  text-align: left;
  margin-bottom: 0;
}

.el-upload__tip {
  width: 60%;
}

.upload-demo {
  display: flex;
}
</style>
